import { gql } from 'apollo-boost';

export const newAllocationMutation = gql`
  mutation newAllocationMutation($reportId: Int!, $investmentId: Int!, $amount: Float!, $tier: String!) {
    newAllocation(reportId: $reportId, investmentId: $investmentId, amount: $amount, tier: $tier) {
      success
      id
    }
  }
`;
